// eslint-disable-next-line no-undef
class ProductGrid extends HTMLElement {
  connectedCallback () {
    this.items = this.querySelectorAll('.product-item')
    this.loadMoreButton = this.querySelector('[data-action="next"]')
    this.currentPage = 1
    this.total = parseInt(this.dataset.total, 10)
    this.perPage = parseInt(this.dataset.step, 10)
    if (this.loadMoreButton) {
      this.loadMoreButton.addEventListener('click', this.loadMore.bind(this))
    }
    console.log(this.dataset.step, this.dataset.total)
  }

  loadMore () {
    this.currentPage++
    const currentTotal = this.currentPage * this.perPage
    this.items.forEach((item, index) => {
      if (index < currentTotal) {
        item.classList.remove('hidden')
      }
    })
    if (currentTotal >= this.total) {
      this.loadMoreButton.parentElement.classList.add('hidden')
    }
  }
}
window.customElements.define('product-grid', ProductGrid)
